module.exports = __webpack_public_path__ + "static/media/rewards-recognitions-logo.8bed12df.svg";